@if (recurring()) {
  <lib-icon class="msa-ab__recurring-icon" [svg]="repeatIconSvg" size="xs" />
}
@if (showLabel()) {
  <p class="msa-ab__label">{{ label() }}</p>
}
@if (showTime()) {
  <p class="msa-ab__time">{{ time() }}</p>
}
